import { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Autocomplete,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box
} from '@mui/material';

// import { Person } from '../../schema/person';
import { Person } from '../../schema/person';

import { Area } from '../../schema/area';
import { GateGroup } from '../../schema/gate';
import { Form } from '../../pages/AdminSetting/SystemManagement';
import { api } from '../../api';

interface InoutStaffProps {
  person_id?: string | number;
  editable?: boolean;
}

const InoutStaff: React.FC<InoutStaffProps> = ({ person_id, editable }: InoutStaffProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  // Permanant permit area
  const [personAreasPP, setPersonAreasPP] = useState<Area[]>([]);
  const [areasPP, setAreasPP] = useState<Area[]>([]);

  const [personGateGroupPP, setPersonGateGroupPP] = useState<GateGroup[]>([]);
  const [GateGroupPP, setGateGroupPP] = useState<GateGroup[]>([]);

  // Temporary permit area
  const [personAreasTP, setPersonAreasTP] = useState<Area[]>([]);
  const [areasTP, setAreasTP] = useState<Area[]>([]);

  const [personGateGroupTP, setPersonGateGroupTP] = useState<GateGroup[]>([]);
  const [GateGroupTP, setGateGroupTP] = useState<GateGroup[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (person_id) {
      setIsLoading(true);
      api
        .post(`/person/${person_id}/inout`, {
          is_active: isActive,
          permanent_gategroup: personGateGroupPP.map((data) => data.id),
          temporary_gategroup: personGateGroupTP.map((data) => data.id)
        })
        .then(() => {
          openSuccessDialog();
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    if (person_id) {
      api.get<Person>(`/person/${person_id}`).then((res) => {
        const { data } = res;
        setIsActive(data.is_active);
      });

      api
        .get<Area[]>(`person/${person_id}/area`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonAreasPP(data);
        });
      api
        .get<Area[]>(`person/${person_id}/area`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonAreasTP(data);
        });

        api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupPP(data);
        });
      api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupTP(data);
        });
    }
  }, [person_id]);

  useEffect(() => {
    if (person_id) {
      api.get<Area[]>(`/area`).then((res) => {
        const { data } = res;
        setAreasPP(data);
        setAreasTP(data);
      });

      api.get<GateGroup[]>(`/gate-group`).then((res) => {
        const { data } = res;
        setGateGroupPP(data);
        setGateGroupTP(data);
      });
    }
  }, [person_id]);

  return (
    <>
      <Typography variant="h6">พื้นที่อนุญาต</Typography>

      <Form onSubmit={handleFormSubmit} sx={{ mt: 2 }}>
        {/* <Grid container spacing={2}>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areasPP}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่อนุญาตถาวร" />}
                value={personAreasPP}
                onChange={(_, value) => setPersonAreasPP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areasPP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่อนุญาตถาวร" />}
                value={personAreasPP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areasTP}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่อนุญาตชั่วคราว" />}
                value={personAreasTP}
                onChange={(_, value) => setPersonAreasTP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areasTP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่อนุญาตชั่วคราว" />}
                value={personAreasTP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          {editable ? (
            <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
              <Grid item>
                <Button type="submit" variant="contained" color="primary">
                  บันทึก
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Grid> */}


        <Grid container spacing={2}>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupPP}
                getOptionLabel={(option) => option.group_name}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตถาวร" />}
                value={personGateGroupPP}
                onChange={(_, value) => setPersonGateGroupPP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupPP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.group_name : option)}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตถาวร" />}
                value={personGateGroupPP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupTP}
                getOptionLabel={(option) => option.group_name}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตชั่วคราว" />}
                value={personGateGroupTP}
                onChange={(_, value) => setPersonGateGroupTP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupTP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.group_name : option)}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตชั่วคราว" />}
                value={personGateGroupTP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          {editable ? (
            <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
              <Grid item>
                <Button type="submit" variant="contained" color="primary">
                  บันทึก
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Form>

      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InoutStaff;
